<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Almost there!</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="password"
            outlined
            label="Password"
            type="password"
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="confirmPassword"
            outlined
            label="Confirm password"
            type="password"
            hint="Must be at least 6 characters long"
            persistent-hint
          />
        </v-col>

        <v-col cols="12">
          <v-btn
            large
            :loading="isLoading"
            :disabled="!isValid"
            block
            color="primary"
            class="accent--text subtitle-1"
            @click="onSetPassword"
          >
            Set password
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    token: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['getMyTenants']),
    isValid() {
      return this.password === this.confirmPassword
        && this.password.length >= 6
    },
  },
  data(){
    return {
      isLoading: false,
      password: '',
      confirmPassword: ''
    }
  },
  methods: {
    ...mapActions([ 'processToken', 'login', 'changeSession']),
    async onSetPassword(){
      // send token with password
      if (this.isValid)  {
        const payload = {
          id: this.token.id,
          password: this.password
        }
        this.isLoading = true
        const result = await this.processToken(payload)
        const { email, tenant } = result

        if (email) {
          const loginPayload = {
            identity: email,
            password: this.password
          }

          await this.login(loginPayload)

          await this.changeSession(tenant)
        }

        this.isLoading = false
      }
    },
    doLogin() {

    }
  }
}
</script>
